import { useCallback, useState } from "react";

export const useManageDrawer = (): [
  boolean,
  { handleOpen: () => void; handleClose: () => void }
] => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => setOpen(true), []);

  const handleClose = useCallback(() => setOpen(false), []);

  return [open, { handleOpen, handleClose }];
};
